import { TIPTAP_LINK_PREVIEW_TYPE, TIPTAP_EMBED_TYPE } from 'ricos-content';
import { convertBlockDataToRicos } from 'ricos-content/libs/convertBlockDataToRicos';
import embedDefaults from 'ricos-schema/dist/statics/embed.defaults.json';
import linkPreviewDefaults from 'ricos-schema/dist/statics/link_preview.defaults.json';
import { createRicosNodeExtension, createRicosFunctionalExtension } from 'wix-rich-content-plugin-commons';
import { fetchLinkPreview, shouldAddEmbed, shouldAddLinkPreview, createLinkPreviewData } from '../lib/utils.js';
import { LINK_PREVIEW_TYPE } from '../types.js';
import { LinkPreview } from './component.js';
import 'lodash';
import '../defaults.js';
import 'ricos-schema';
import 'react';
import '../viewer/link-preview-viewer.js';
import 'ricos-context';
import 'wix-rich-content-common';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';
import 'wix-rich-content-ui-components';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const urlRegex = (
  // eslint-disable-next-line max-len
  /(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi
);
const urlRegexExact = new RegExp("^" + urlRegex.source + "$", "gi");
const isLinkOnlyBlock = ({ parent, nodeBefore }) => {
  var _a;
  return parent.childCount === 1 && ((_a = nodeBefore == null ? void 0 : nodeBefore.text) == null ? void 0 : _a.search(urlRegexExact)) !== -1;
};
const addLinkPreview = (config) => ({ editor }) => {
  var _a, _b;
  const pos = editor.state.selection.$anchor;
  const {
    enableEmbed = true,
    enableLinkPreview = true,
    fetchData,
    link: linkConfig
  } = config || {};
  if (((_a = pos.nodeBefore) == null ? void 0 : _a.text) && isLinkOnlyBlock(pos) && fetchData && (enableEmbed || enableLinkPreview)) {
    let isPreviewAdded = false;
    const { target, rel } = linkConfig || {};
    const url = (_b = pos.nodeBefore) == null ? void 0 : _b.text;
    fetchLinkPreview(fetchData, url).then((linkPreviewData) => {
      const shouldEmbed = shouldAddEmbed(
        linkPreviewData.html,
        enableEmbed,
        linkPreviewData.fixedUrl
      );
      if (shouldEmbed || shouldAddLinkPreview(linkPreviewData.title, enableLinkPreview)) {
        isPreviewAdded = true;
        return createLinkPreviewData({ url, target, rel }, linkPreviewData, config).then(
          (linkPreviewComponentData) => {
            var _a2;
            const convertedLinkPreviewData = convertBlockDataToRicos(
              LINK_PREVIEW_TYPE,
              linkPreviewComponentData
            );
            editor.chain().focus().deleteRange({ from: pos.pos - (((_a2 = pos.nodeBefore) == null ? void 0 : _a2.nodeSize) || 0), to: pos.pos }).insertContent([
              {
                type: shouldEmbed ? TIPTAP_EMBED_TYPE : TIPTAP_LINK_PREVIEW_TYPE,
                attrs: convertedLinkPreviewData
              },
              { type: "PARAGRAPH" }
            ]).run();
          }
        );
      }
    }).finally(() => {
    });
    return isPreviewAdded;
  }
  return false;
};
const tiptapExtensions = [
  createRicosNodeExtension({
    name: TIPTAP_LINK_PREVIEW_TYPE,
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => settings
    }),
    Component: LinkPreview,
    createExtensionConfig() {
      return {
        group: "block",
        selectable: true,
        draggable: true,
        name: this.name,
        addAttributes: () => linkPreviewDefaults,
        addCommands() {
          return {
            setLinkPreview: (attributes) => ({ commands }) => {
              return commands.setNode("linkPreview", attributes);
            }
          };
        }
      };
    }
  }),
  createRicosNodeExtension({
    name: TIPTAP_EMBED_TYPE,
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => settings
    }),
    Component: LinkPreview,
    createExtensionConfig() {
      return {
        group: "block",
        selectable: true,
        draggable: true,
        name: this.name,
        addAttributes: () => embedDefaults
      };
    }
  }),
  createRicosFunctionalExtension({
    type: "extension",
    groups: ["shortcuts-enabled"],
    name: "linkPreviewEnter",
    reconfigure: (config, _extensions, _props, settings, services) => __spreadProps(__spreadValues({}, config), {
      addKeyboardShortcuts() {
        const newLine = addLinkPreview(settings);
        const tiptapKeyboardShortcuts = {
          Enter: newLine
        };
        const newLineShortcuts = [];
        services.shortcuts.shortcuts.forEach((shortcut) => {
          if (shortcut.shortcut.name === "NewLine") {
            newLineShortcuts.push(shortcut);
          }
        });
        newLineShortcuts.forEach((newLineShortcut) => {
          const modifier = newLineShortcut.keys.macOs.modifiers[0];
          const key = newLineShortcut.keys.macOs.key;
          const shortcutKey = modifier ? `${modifier}-${key}` : key;
          tiptapKeyboardShortcuts[shortcutKey] = newLine;
        });
        return __spreadValues({}, tiptapKeyboardShortcuts);
      }
    }),
    createExtensionConfig() {
      return {
        name: this.name,
        priority: 101
      };
    }
  })
];

export { tiptapExtensions, urlRegex, urlRegexExact };
//# sourceMappingURL=tiptap.js.map
